<template>
  <v-container class="file-upload pa-0"
               fluid>

    <v-row no-gutters>
      <v-col cols="12"
             sm="10"
             md="8"
             lg="6">
        <div v-for="(file, index) in files"
             :key="'' + index + '-' + file.id"
             class="file-item">

          <v-container fluid
                       class="pa-0">
            <v-row class="file-row bg-dimmed flex-nowrap"
                   no-gutters>
              <v-col class="dbg check-file">
                <v-icon v-if="file.xhr && file.success && file.progress == 100"
                        color="primary">check
                </v-icon>
                <span v-else-if="file.active">&nbsp;</span>
                <v-icon v-if="file.error"
                        color="error">warning
                </v-icon>
              </v-col>
              <v-col class="dbg file-info pr-6">
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                          v-on="on">{{ file.name }} {{ file.size | formatSize }}</span>
                  </template>
                  <span class="caption">{{ file.name }} {{ file.size | formatSize }}</span>
                </v-tooltip>
                <span v-if="file.error"
                      class="file-error error--text"><br>{{ file.error | formatError }}</span>
              </v-col>
              <div class="delete-file dbg">
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-icon v-if="true"
                            v-on="on"
                            @click="removeFile(file)">close
                    </v-icon>
                  </template>
                  <span class="caption">Dokument löschen</span>
                </v-tooltip>
              </div>
            </v-row>
            <v-progress-linear v-model="file.progress"
                               color="primary"
                               class="ma-0"
                               height="4" />
          </v-container>
        </div>
      </v-col>

      <v-col cols="12">
        <v-row no-gutters align="center" @mouseover="mouseOver" @mouseleave="mouseLeave" >
          <!-- CORS is not working for File upload so please test running on the same host,
           if you have to use a different host (eg. localhost)
           use Chrome like this chrome.exe --disable-web-security --user-data-dir="c:/chromedev") -->
          <file-upload v-show="files.length < 3"
                       ref="upload"
                       v-model="files"
                       :size="1024 * 1024 * 5"
                       :post-action="getPostPath()"
                       :multiple="false"
                       :maximum="3"
                       name="files"
                       extensions="pdf"
                       @input-file="inputFile">
            <span class="btn-add-upload">
              <v-icon class="hov">add</v-icon>
              <span class="hov">Dokument hinzufügen&nbsp;</span>
            </span>
          </file-upload>
          <site-tooltip>Hier haben sie die Möglichkeit, Dateien hochzuladen. Dem Antrag können bis zu drei zusätzliche PDF-Dokumente hinzugefügt werden. Die maximale Größe beträgt 5 MB pro Datei.</site-tooltip>
          <error-message-display :errors="errorSnackbar" />
        </v-row>
      </v-col>

    </v-row>
  </v-container>
</template>
<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import ErrorMessageDisplay from "@/components/ErrorMessageDisplay";
/* hidden original input
import 'vue-upload-component/dist/vue-upload-component.part.css';
import VueUploadComponent from "vue-upload-component/dist/vue-upload-component.part.js";
*/
import VueUploadComponent from "vue-upload-component";
import {API_URL} from "@/helper/httpService";

export default {
  name: "FileUploadMulti",
  components: {
    ErrorMessageDisplay,
    FileUpload: VueUploadComponent
  },
  filters: {
    formatSize: function (size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return "(" + (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB)";
      } else if (size > 1024 * 1024 * 1024) {
        return "(" + (size / 1024 / 1024 / 1024).toFixed(2) + " GB)";
      } else if (size > 1024 * 1024) {
        return "(" + (size / 1024 / 1024).toFixed(2) + " MB)";
      } else if (size > 1024) {
        return "(" + (size / 1024).toFixed(2) + " KB)";
      }
      return size.toString() + " B)";
    },
    formatError: function (msg) {
      if (msg === "size") {
        return "maximale Dateigröße von 5 MB überschritten";
      } else if (msg === "denied") {
        return "Anmeldung abgelaufen";
      } else if (msg === "network") {
        return "keine Netzwerkverbindung";
      } else if (msg === "extension") {
        return "ist keine PDF-Datei";
      } else {
        return msg;
      }
    }
  },
  mixins: [twowayBinding],
  data: function () {
    return {
      uploadAuto: true,
      errorSnackbar: {
        errormessages: [],
        displayerrors: false
      }
    };
  },
  computed: {
    ...mapTwoWay(["fileIds", "files"])
  },
  methods: {
    mouseOver: function() {
      // since css :hover does not work inside the Fileupload Control, styling must be done by JS
      let elems = document.querySelectorAll('.file-upload .hov');
      elems.forEach( elem => elem.style.color="#0085cf" );
    },
    mouseLeave: function() {
      let elems = document.querySelectorAll('.file-upload .hov');
      elems.forEach( elem => elem.style.color="" );
    },
    /**
     * Has changed
     * @param  {Object|undefined}   newFile   Read only
     * @param  {Object|undefined}   oldFile   Read only
     * @return undefined
     */
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile) {
        // additional update handling on folowing hooks: beforeSend, progress, error, success, remove can be inserted here if needed

        if (newFile.active && !oldFile.active) {
          //hook beforeSend

          //hook min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.upload.update(newFile, { error: "size" });
          }
        }

        if (newFile.progress !== oldFile.progress) {
          //hook progress
        }

        if (newFile.error && !oldFile.error) {
          //hook error
        }

        if (newFile.success && !oldFile.success) {
          //hook success
          //update the file id array that is used to make the relation between files and offers/orders in the database
          this.fileIds = [
            ...this.fileIds,
            {
              fileid: newFile.id,
              id: newFile.response[0].id,
              filename: newFile.response[0].filename
            }
          ];
        }
      }

      if (!newFile && oldFile) {
        //hook remove
        if (oldFile.success && oldFile.response.id) {
          // we don't ajax-delete uploaded files here because
          // - one file can be linked to multiple offers
          // - the actual offer may or may not exist in the databse jet
          // - offer files will be deleted after 12 month anyway
          // - orphan files can be identified and deleted even earlier
        }
      }

      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }

      // handling response data
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log("response", newFile.response);

        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
          /* mapping from xhr
            this.fileIds[newFile.id] = {
            id: JSON.parse(newFile.xhr.response)[0].id,
            filename: JSON.parse(newFile.xhr.response)[0].filename
          }
          */
        }
      }
    },
    /**
     * Pretreatment add @input-filter="inputFilter" to upload control to enable
     * @param  {Object|undefined}   newFile   Read and write
     * @param  {Object|undefined}   oldFile   Read only
     * @param  {Function}           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-pdf file
        this.errorSnackbar.errormessages = [];
        if (!/\.(pdf)$/i.test(newFile.name)) {
          this.errorSnackbar.errormessages.push("Bitte wählen Sie nur PDF-Dokumente aus!");
          this.errorSnackbar.displayerrors = true;
          return prevent();
        }
      }

      // Create a blob field
      if (newFile) {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
      }
    },
    removeFile(file) {
      this.$refs.upload.remove(file);
      this.$store.commit("removeFile", file);
      this.fileIds = this.fileIds.filter(
        f => (f.fileid !== file.id)
      );
    },
    getPostPath() {
      return API_URL + "uploadtodb";
    }
  }
};
</script>
<style>
.file-upload .btn-add-upload {
  font-size: 16px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
}

.file-upload .btn-add-upload .v-icon, .file-upload .btn-add-upload span {
  color: rgba(0, 0, 0, .87);
  cursor: pointer;
  margin-right: 4px !important;
}

/*since :hover seems to be blocked color is applied by mouseover additionaly */ 
.file-upload .btn-add-upload:hover, .file-upload .btn-add-upload:hover span, .file-upload .btn-add-upload:hover .v-icon, .file-upload .btn-add-upload span:hover {
  color: #0085CF !important;
}

/* tricky part: setting cursor on an dynamic label created by the component*/
.file-upload label {
  cursor: pointer !important;
}

.file-upload .file-item {
  /*position: relative;*/
  padding-bottom: 16px;
  font-size: 16px;
}

.file-upload .file-row {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 8px;
  position: relative;
}

.file-upload .file-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-upload .file-error {
  font-size: 16px;
}

.file-upload .delete-file {
  position: absolute;
  top: 16px;
  right: 8px;
}

.file-upload .check-file {
  padding-left: 12px;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: 48px;
}
</style>
